import React from 'react';
import { Document, Page, Text, View, Image, StyleSheet } from '@react-pdf/renderer';
import Logo from '../../../../Styles/imagenes/Logo Maquinaria.png';
import { FormatMoney } from "../../../../Helpers/FormatNumber";

// Estilos personalizados
const styles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        backgroundColor: '#ffffff',
    },
    titulo: {
        backgroundColor: '#477c2c',
        height: 57,
        marginTop: 51,
        textAlign: 'center',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    tituloTexto: {
        fontSize: 22,
        marginLeft: 20,
    },
    imagenContainer: {
        position: 'absolute',
        top: 0,
        left: 50,
    },
    logoImagen: {
        width: 150,
    },
    table: {
        marginTop: 80,
        marginLeft: 30,
        marginRight: 30,
        display: 'table',
        width: 'auto',
        borderRadius: 5,
        borderWidth: 1,

    },
    tableRow: {
        flexDirection: 'row',
        marginTop: 5,
        borderBottomWidth: 1
    },
    tableRowTitulo: {
        flexDirection: 'row',
        borderBottomWidth: 3,
        borderColor: '#fedb05',
        backgroundColor: '#275027',
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,

    },
    tableCol: {
        width: '50',

    },
    tableColRS: {
        width: '150',

    },
    tableCell: {
        marginRight: 5,
        textAlign: 'right',
        fontSize: 8,
        height: 20,

    },
    tableCellTitulo: {
        fontSize: 10,
        height: 15,
        borderLeftWidth: 2,
        borderColor: '#fedb05'

    },
    tableCellSucursal: {
        marginLeft: 5,
        textAlign: 'left',
        fontSize: 10,
        height: 20,

    },
    tituloFila: {

        color: '#fff',
    },
    textoTituloFila: {
        marginTop: '5%',
        textAlign: 'center'
    },
});

const TotalCarteraDetallePDF = ({ data }) => (
    <Document>
        <Page size="A4" orientation="landscape" style={styles.page} >
            <View>
                <View style={styles.titulo}>
                    <Text style={styles.tituloTexto}>RESUMEN CARTERA DETALLE</Text>
                </View>
                <View style={styles.imagenContainer}>
                    <Image src={Logo} style={styles.logoImagen} />
                </View>

                <View style={styles.table}>
                    <View style={{ ...styles.tableRowTitulo, ...styles.tituloFila }}>
                        <View style={styles.tableCol}>
                            <Text style={{ ...styles.tableCell, ...styles.textoTituloFila }}>Sucursal</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={{ ...styles.tableCellTitulo, ...styles.textoTituloFila }}>ID</Text>
                        </View>
                        <View style={styles.tableColRS}>
                            <Text style={{ ...styles.tableCellTitulo, ...styles.textoTituloFila }}>Razon Social</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={{ ...styles.tableCellTitulo, ...styles.textoTituloFila }}>Documento</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={{ ...styles.tableCellTitulo, ...styles.textoTituloFila }}>Vencimiento</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={{ ...styles.tableCellTitulo, ...styles.textoTituloFila }}>Días</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={{ ...styles.tableCellTitulo, ...styles.textoTituloFila }}>Importe</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={{ ...styles.tableCellTitulo, ...styles.textoTituloFila }}>Intereses</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={{ ...styles.tableCellTitulo, ...styles.textoTituloFila }}>Total</Text>
                        </View>
                    </View>
                    {data.map((item, index) => (
                        <View style={styles.tableRow} key={index}>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCellSucursal}>{item.sucursal}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>{item.idcliente}</Text>
                            </View>
                            <View style={styles.tableColRS}>
                                <Text style={styles.tableCell}>{item.razonsocial}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>{item.documento}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>{item.vencimiento}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>{item.diasvencido}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>{FormatMoney(item.saldo)}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>{FormatMoney(item.interesbase)}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>$ {FormatMoney(item.importe)}</Text>
                            </View>
                        </View>

                    ))}
                </View>
            </View>
        </Page>
    </Document>
);

export default TotalCarteraDetallePDF;
